module.exports = __webpack_public_path__ + "media/2_3.bc135e3b.wav";